import styles from "./styles.module.scss";

export const HomePage: React.FC = () => {
	return (
		<div className={styles.container}>
			<h1>Em construção</h1>
		</div>
	);
};
